export type TranslationResources = { [k: string]: string };
export type TransFN = (str: string) => string;
/**
 * Funkce pro preklad textu pomocí angular lokalizace
 * @param translationResources reference na zdrojove texty ve formatu objektu klic-hodnota
 * @param str kod textu k prekladu
 * @returns  prelozeny text
 */
export function t(
  translationResources: TranslationResources,
  str: string
): string {
  return (
    translationResources[str] ??
    $localize`:@@translationDefault:CHYBA - Nepřeložený text: ` + str
  );
}

export interface ITranslatedComponent {
  translationResources: TranslationResources;
  t: TransFN;
}
